import { motion } from "framer-motion";
import { ProductReviewItemProps } from "./constants";
import { motionVariants } from "../Common/GlobalVars";
import Image from "next/image"


interface ReviewProps {
  review: ProductReviewItemProps;
  full_review: boolean;
}

const Review = (props: ReviewProps) => {
  const { review, full_review } = props;

  const render_rating = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => {
      if (i < rating) {
        return (
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/star.png"}
            alt="star icon"
            width={16}
            height={16}
            quality={100}
            key={i}
          />
        )
      } else if (i < rating + 1) {
        return (
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/half-star.png"}
            alt="half star icon"
            width={16}
            height={16}
            quality={100}
            key={i}
          />
        )
      } else {
        return (
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/empty-star.png"}
            alt="empty star icon"
            width={16}
            height={16}
            quality={100}
            key={i}
          />
        )
      }
    });
  }

  return (
    <motion.div
      className="p-4 border rounded-lg border-reviewBg font-poppins"
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true }}
      variants={motionVariants}
    >
      <div className="flex items-center justify-between text-productReview">
        <p className="text-base font-medium">{review.customer_name}</p>
        <p className="text-sm font-normal">{review.review_date}</p>
      </div>
      <div className="flex items-center mt-2 space-x-2">
        {render_rating(review.star_value)}
      </div>
      <div className="mt-4 text-base font-bold text-black line-clamp-1" dangerouslySetInnerHTML={{ __html: review.title.length > 0 ? review.title : "&nbsp;"}}></div>
      <div className={`mt-4 text-[13px] text-productReview ${full_review ? "" : "line-clamp-3 h-[58.5px]"}`}>{review.content}</div>
      <div className={`${full_review ? "flex" : "hidden md:flex"} flex-wrap space-x-2 mt-4 h-20`}>
        {review.image_list.slice(0, 3).map((image, index) => (
          <Image
            src={image.image}
            alt={`review image ${index + 1}`}
            width={80}
            height={80}
            quality={100}
            key={index}
            className="!object-cover h-20 w-20"
          />
        ))}
      </div>
    </motion.div>
  )
}

export default Review;
